import { jsx } from "panel";
import { nameToInitials } from "common/util/string";
import { TooltipEl } from "common/components/tooltip";
import emptyIconImage from "./empty-icon.svg";
import mpAvatarUrl from "./mp-avatar.svg";
const ImageIcon = ({
  src,
  iconSize,
  handleAvatarImageLoaded,
  elref,
  isAvatarImageLoaded = true
}) => /* @__PURE__ */ jsx("div", {
  sel: ".image-icon.color-avatar",
  class: { loading: !isAvatarImageLoaded }
}, /* @__PURE__ */ jsx("img", {
  attrs: {
    elref,
    align: `middle`,
    src,
    loading: `lazy`
  },
  style: {
    height: iconSize,
    width: iconSize
  },
  on: {
    load: handleAvatarImageLoaded
  }
}));
const InitialsIcon = ({ name, backgroundClassName }) => /* @__PURE__ */ jsx("div", {
  class: { [backgroundClassName]: true, "initials-icon": true },
  attrs: { elref: `initialsIcon` }
}, nameToInitials(name));
const Placeholder = ({ userIcon, iconSize, name }) => {
  if (name) {
    return /* @__PURE__ */ jsx(InitialsIcon, {
      name,
      backgroundClassName: userIcon.helpers.getBackgroundColorClass()
    });
  }
  return /* @__PURE__ */ jsx(ImageIcon, {
    src: emptyIconImage,
    iconSize,
    isAvatarImageLoaded: true,
    elref: "defaultImg"
  });
};
const Avatar = ({ userIcon, iconSize, name }) => {
  const avatarUrl = userIcon.helpers.getAvatarUrl();
  const { isAvatarImageLoaded } = userIcon.state;
  if (avatarUrl) {
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ImageIcon, {
      src: avatarUrl,
      iconSize,
      isAvatarImageLoaded,
      elref: "userImg",
      handleAvatarImageLoaded: userIcon.helpers.handleAvatarImageLoaded
    }), isAvatarImageLoaded ? null : /* @__PURE__ */ jsx(Placeholder, {
      userIcon,
      iconSize,
      name
    }));
  }
  return /* @__PURE__ */ jsx(Placeholder, {
    userIcon,
    iconSize,
    name
  });
};
export function template() {
  const { iconSize, fontSize } = this.helpers.getIconProperties();
  const name = this.helpers.getDisplayName();
  const labelPrefix = this.attr(`label-prefix`);
  const labelSuffix = this.attr(`label-suffix`);
  const label = `${labelPrefix} ${name} ${labelSuffix}`.trim();
  return /* @__PURE__ */ jsx("div", {
    class: {
      clickable: this.helpers.shouldOpenSidebar(),
      container: true
    },
    attrs: { tabindex: 0 },
    on: {
      click: this.helpers.handleIconClick,
      keypress: this.helpers.handleIconClick
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".avatar-container",
    style: {
      "font-size": `${fontSize}px`,
      height: `${iconSize}px`,
      "line-height": `${iconSize}px`,
      width: `${iconSize}px`,
      "min-width": `${iconSize}px`
    },
    class: { "is-staff-member-image": !!this.attr(`staff-member-avatar-uuid`) }
  }, /* @__PURE__ */ jsx(Avatar, {
    userIcon: this,
    iconSize: `${iconSize}px`,
    name
  }), this.attr(`staff-member-avatar-uuid`) && /* @__PURE__ */ jsx("img", {
    sel: ".staff-member-image-overlay",
    attrs: { src: mpAvatarUrl }
  })), !this.attr(`disable-tooltip`) && this.attr(`name`) && /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: this.attr(`tooltip-placement`), offset: 12 }
  }, labelPrefix && /* @__PURE__ */ jsx("div", {
    sel: ".tooltip-subtitle"
  }, labelPrefix), /* @__PURE__ */ jsx("div", {
    sel: ".tooltip-text"
  }, name), labelSuffix && /* @__PURE__ */ jsx("div", {
    sel: ".tooltip-subtitle"
  }, labelSuffix)), this.attr(`include-label`) ? /* @__PURE__ */ jsx("div", {
    sel: ".label",
    attrs: { elref: `label` },
    style: { "line-height": `${iconSize}px` }
  }, label) : null);
}
